import EndShowModal from '@/components/modal/EndShowModal'
import { useRundownPermission } from '@/features/permissions/lib/use-rundown-permission'
import { getNowAtom, runnerAtom } from '@/store/runner.store'
import { RundownPermission } from '@rundown-studio/types'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { useTransportActions } from '../transport/transport'

export function RundownHeaderEndShow() {
  const runner = useAtomValue(runnerAtom)
  const getNow = useAtomValue(getNowAtom)

  const isShowCaller = useRundownPermission({
    permission: RundownPermission.SHOWCALL,
  })

  const [endShowDismissed, setEndShowDismissed] = useState(false)

  /**
   * Show "End Show?" modal when the show has been running 1h+ past its scheduled end.
   * Avoids users opening a stale rundown that's still running and making edits while
   * the UI updates every 100ms. Dismissed once the user makes a choice.
   */
  const endShowModalOpen = Boolean(
    runner &&
    isShowCaller &&
    !endShowDismissed &&
    runner.timesnap.cueId !== null &&
    runner.timesnap.deadline - getNow() < -1000 * 60 * 60,
  )

  const { onEndRunner } = useTransportActions()

  async function handleEndShow() {
    setEndShowDismissed(true)
    await onEndRunner()
  }

  return (
    <EndShowModal
      open={endShowModalOpen}
      setOpen={(open) => {
        if (!open) setEndShowDismissed(true)
      }}
      onEndShow={handleEndShow}
    />
  )
}
